module.exports = __webpack_public_path__ + "img/Roboto-Bold-webfont.73d4f283.svg";